import { ArrowRight } from "lucide-react";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen w-full flex flex-col justify-between overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/8259341/pexels-photo-8259341.jpeg)",
          opacity: 0.22,
        }}
      />
      <div className="absolute inset-0 hero-vignette" />

      {/* Top bar */}
      <div className="relative z-10 px-6 md:px-12 pt-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-[#C9A961] animate-pulse" />
          <span className="font-mono-detail text-[0.7rem] tracking-[0.28em] uppercase text-[#A19D9B]">
            Shadow / Operator
          </span>
        </div>
      </div>

      {/* Hero content */}
      <div className="relative z-10 px-6 md:px-12 pb-20 md:pb-32 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-10 lg:col-span-9">
          <div className="overline section-mark mb-8">Growth Operator — est. quietly</div>
          <h1
            data-testid="hero-headline"
            className="font-serif-display text-[2.75rem] sm:text-7xl md:text-8xl lg:text-[8.5rem] font-light tracking-[-0.03em] leading-[0.95] text-[#F2E7DF] break-words"
          >
            Your Audience.
            <br />
            <span className="italic text-[#E5C16C]">Fully</span> Monetised.
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-10 max-w-xl text-lg md:text-xl text-[#A19D9B] font-light leading-relaxed"
          >
            I build the offers, funnels and product launches that turn an audience
            into recurring revenue — entirely behind the scenes. You stay the face.
            I run the machine.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-button"
              onClick={() => scrollToId("contact")}
              className="btn-burgundy"
            >
              Work With Me <ArrowRight size={16} strokeWidth={1.5} />
            </button>
            <button
              data-testid="hero-secondary-cta"
              onClick={() => scrollToId("how-it-works")}
              className="btn-ghost"
            >
              How it works
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
